import { render, staticRenderFns } from "./taskAdmin.vue?vue&type=template&id=9526fad8&scoped=true&"
import script from "./taskAdmin.vue?vue&type=script&lang=js&"
export * from "./taskAdmin.vue?vue&type=script&lang=js&"
import style0 from "./taskAdmin.vue?vue&type=style&index=0&id=9526fad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9526fad8",
  null
  
)

export default component.exports